<template lang="pug">
  .login
    .login__preview.login__wrap
      .login__title
        h1 Ilvaco -We make Amazon returns seamless!
      .login__footer
        .login__info
          .login__copyright
            span &copy; Ilvaco
    .login__signin.login__wrap
      .login__signup-label
        span Don't have an account yet?
        | &nbsp;&nbsp;
        router-link.link(to="/register") Sign Up!
      sign_in_component
</template>

<script>
import signIn from '../../components/sign_in/sign_in.vue';

export default {
  components: {
    sign_in_component: signIn,
  },
};
</script>
<style src="./login.styl" lang="stylus" scoped></style>
